import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';

interface ConfigTile {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
}

const TILES_PER_ROW = 3;

const renderTile = (tile: ConfigTile, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? 'ods-grid__column--4 ods-color-text-grayscale-10' : 'ods-grid__column--4'}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const ConfigView: React.FC<RouteComponentProps> = () => {
  const tiles: ConfigTile[] = [
    { label: 'Friidrettsregistrering', icon: 'ods-icon--document', href: '/config/athleticsregistration', disabled: false },
  ];

  const rows: ConfigTile[][] = [];
  for (let i = 0; i < tiles.length; i += TILES_PER_ROW) {
    rows.push(tiles.slice(i, i + TILES_PER_ROW));
  }

  return (
    <>
      <OKomBreadcrumb path='Konfigurasjon'></OKomBreadcrumb>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="ods-grid ods-grid--gap-row-large ods-margin-top-11 ods-text--align-center">
          <div className="ods-grid__column--12">
            <div className="ods-grid ods-grid--gap ods-grid--center">
              {row.map((tile, colIndex) => renderTile(tile, rowIndex * TILES_PER_ROW + colIndex))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default withRouter(ConfigView);
